import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailedProductDescriptionComponent } from '../../../../core/components/detailed-product-description/detailed-product-description.component';
import {
  PostRequestBase,
  ResponseBase,
  RequestData,
  ScreenModel,
} from '../../../../core/models/common';
import {
  Product,
  ProductDetailDescription,
  ProductServerData,
  ProductOptionServerData,
  RiskLevel,
  ProductOption,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SideBarService } from '../../../../core/services/side-bar.service';
import { requiredIfValidator } from '../../../../core/utilities/validator';
import { SharedAPIService } from '../../../../core/services/shared-api.service';
import { async } from '@angular/core/testing';


// What we receive from the API when page is loaded
export interface RecommendedProductsData extends ResponseBase {
  IsAcceptRecommendedProducts: boolean | null;
  IsPurchaseTableBProducts: boolean | null;
  AssessedRiskProfile: string;
  HasSelectedNonRecommendedProducts?: boolean;
}

// What we will send to the API when submit
export interface RecommendedProductsRequestData extends PostRequestBase {
  IsAcceptRecommendedProducts?: boolean | null;
  IsPurchaseTableBProducts?: boolean | null;
}

// What we work with in this screen.
export class RecommendedProductsModel extends ScreenModel {
  screenName = 'RecommendedProducts';
  pageID_write = 'S0080';
  pageID_productDetails = 'R0080';
  data: RecommendedProductsData | undefined;
  recommendedProducts: ProductOption[] = [];
  isAcceptRecommendedProducts: boolean | null = null;
  isPurchaseTableBProducts: boolean | null = null;
  recommendedProductsDetailDescription?: ProductDetailDescription;
  nonRecommendedProductsDetailDescription?: ProductDetailDescription;
  assessedRiskProfile: string = '';
  hasSelectedNonRecommendedProducts?: boolean;
  sharedAPIService : any;
  selectedProductListTableA:any[] = [];
  recommendedProductsHolder : any;
  RecommendedProductsDetailDescriptionHolder:any;
  NonRecommendedProductsDetailDescriptionHolder:any;



  // Data lifecycle start.

  getLoadDataFromSession=()=>{
    return this.sharedAPIService.retrieveProductDetails();
  }
  mapPegaObjSavedToUI(data : any){
    console.log("PRODUCTS PAGE+++++++")
    console.log(this.sharedAPIService.getTableABDesc())
    const tableADescList = this.sharedAPIService.getTableABDesc()['tableA']
    const tableBDescList = this.sharedAPIService.getTableABDesc()['tableB']
    
      this.RecommendedProductsDetailDescriptionHolder= {
          lowRiskDescription: tableADescList[0],
          moderateRiskDescription: tableADescList[1],
          highRiskDescription: tableADescList[2]
        }
      this.NonRecommendedProductsDetailDescriptionHolder= {
          lowRiskDescription: tableBDescList[0],
          moderateRiskDescription: tableBDescList[0],
          highRiskDescription: tableBDescList[0]
        }
   
    this.recommendedProductsHolder = this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA'])
    
    let recommendedProductsData:RecommendedProductsData  = {
        //RecommendedProductsType: this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA']),
        IsAcceptRecommendedProducts: data['ProductDetails']['AcceptProductsInTableA']=='Yes'?true:data['ProductDetails']['AcceptProductsInTableA']=='No'?false:null,
        IsPurchaseTableBProducts:data['ProductDetails']['PurchaseOtherProductsInTableB']=='Yes'?true:data['ProductDetails']['PurchaseOtherProductsInTableB']=='No'?false:null,
        // RecommendedProductsDetailDescription: {
        //   LowRiskDescription: tableADescList[0],
        //   ModerateRiskDescription: tableADescList[1],
        //   HighRiskDescription: tableADescList[2]
        // },
        // NonRecommendedProductsDetailDescription: {
        //   LowRiskDescription: tableBDescList[0],
        //   ModerateRiskDescription: tableBDescList[0],
        //   HighRiskDescription: tableBDescList[0]
        // },
        AssessedRiskProfile: this.sharedAPIService.getAssessedRiskProfile()
      }
     return recommendedProductsData ;
   }
 
  
   deriveFromData(data: RecommendedProductsData) {
     
    this.recommendedProducts = this.recommendedProductsHolder.map(
      (product: ProductOptionServerData) => {
        return {
          id: product.Id,
          riskLevel: product.RiskLevel,
          title: product.Title,
          description: product.Description,
          shortDescription: product.ShortDescription,
          isChecked:product.IsChecked
        };
      },
    );
    this.isAcceptRecommendedProducts = data.IsAcceptRecommendedProducts;
    this.isPurchaseTableBProducts = data.IsPurchaseTableBProducts;
    this.recommendedProductsDetailDescription =
    this.RecommendedProductsDetailDescriptionHolder;
    this.nonRecommendedProductsDetailDescription =
      this.NonRecommendedProductsDetailDescriptionHolder
    this.assessedRiskProfile = data.AssessedRiskProfile;

    console.log('deriveFromData, model:', this);
  }

  decideTableAProducts(){
    if (this.assessedRiskProfile === RiskLevel.CONSERVATIVE) {
      this.selectedProductListTableA=['LowRisk']
    } else if (this.assessedRiskProfile === RiskLevel.MODERATE) {
      this.selectedProductListTableA=['LowRisk','ModerateRisk']
    } else if (this.assessedRiskProfile === RiskLevel.AGGRESSIVE) {
      this.selectedProductListTableA=['LowRisk','ModerateRisk','HighRisk']
    }
  }
  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): RequestData {
    // @For integration.
    // return {
    //   IsAcceptRecommendedProducts: this.isAcceptRecommendedProducts,
    //   IsPurchaseTableBProducts: this.isPurchaseTableBProducts,
    // };
    console.log("DATAT\n"+this.savedData)
    console.log(this.savedData)
    
    //this.updateSavedData()
    return {
      ServiceBody :this.savedData
    };
  }

  updateSavedData(){
    this.syncModelWithForm();
    
    if(this.isAcceptRecommendedProducts){
      this.decideTableAProducts();
      this.selectedProductListTableA.forEach(riskLevel=>{
        this.savedData['ProductDetails']['TableA'][riskLevel].forEach((product:any)=>{
          if(!product.ProductName.toLowerCase().includes('others')){
            product.pySelected = true;
          }
         
        })
      })
    }else{
      this.decideTableAProducts();
      this.selectedProductListTableA.forEach(riskLevel=>{
        this.savedData['ProductDetails']['TableA'][riskLevel].forEach((product:any)=>{
          product.pySelected = false;
        })
      })
    }
  
    if(this.isPurchaseTableBProducts==false){
      ['LowRisk','ModerateRisk','HighRisk'].forEach(riskLevel=>{
        this.savedData['ProductDetails']['TableB'][riskLevel].forEach((product:any)=>{
          product.pySelected = false;
        })
      })
    }
    this.savedData['ProductDetails']['AcceptProductsInTableA'] = this.isAcceptRecommendedProducts==true?'Yes':this.isAcceptRecommendedProducts==false?'No':''
    this.savedData['ProductDetails']['PurchaseOtherProductsInTableB'] = this.isPurchaseTableBProducts==true?'Yes':this.isPurchaseTableBProducts==false?'No':''
    
    this.sharedAPIService.storeProductDetailsToSS(this.savedData)
  }

  // Data lifecycle end.

  syncModelWithForm() {
    console.log('[RecommendedProductsModel] syncModelWithForm');
    const formValues = this.form?.value;
    this.isAcceptRecommendedProducts = formValues.isAcceptRecommendedProducts;
    this.isPurchaseTableBProducts = formValues.isPurchaseTableBProducts;

    if (this.globals.simulateServerBehaviour) {
      this.globals.mockIsAcceptRecommendedProducts =
        formValues.isAcceptRecommendedProducts;
      this.globals.mockIsPurchaseTableBProducts =
        formValues.isPurchaseTableBProducts;
    }
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-recommended-products',
  templateUrl: './recommended-products.component.html',
  styleUrls: ['./recommended-products.component.scss'],
})
export class RecommendedProductsComponent implements OnInit {
  @ViewChild('confirmationModal')
  confirmationModal: ElementRef | undefined;

  hasClearedPreviouslySelectedProducts: boolean = false;

  model = new RecommendedProductsModel(this.globals, this.apiService, this.el);
  form: FormGroup = this.formBuilder.group({
    isAcceptRecommendedProducts: [undefined, [Validators.required]],
    isPurchaseTableBProducts: [
      undefined,
      [
        requiredIfValidator(
          () => this.isAcceptRecommendedProductsControl.value === true,
        ),
      ],
    ],
  });

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private el: ElementRef,
    private sideBarService: SideBarService,
    private sharedAPIService : SharedAPIService
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.sharedAPIService = this.sharedAPIService
  }

  async ngOnInit() {
    console.log('[RecommendedProductsComponent] Page Onload');
    const savedProductDataFromPrevScreen= this.sharedAPIService.getTableABDesc();
  
      this.model.productDetailResponse = await this.model.callMiscService(this.model.pageID_productDetails,{})
      this.sharedAPIService.storeProductDetailsToSS(this.model.productDetailResponse)
 
      let tableADescList =  this.sharedAPIService.createTableAData(this.model.productDetailResponse.ProductDetails.TableA)
     let tableBDescList =  this.sharedAPIService.createTableAData(this.model.productDetailResponse.ProductDetails.TableB)
     this.sharedAPIService.setTableABDesc({
       tableA:tableADescList,
       tableB:tableBDescList
     }) 
      await this.model.loadDataSaved();
      this.formControlValueChanged();
    
   
   
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    this.isAcceptRecommendedProductsControl.setValue(
      this.model.isAcceptRecommendedProducts,
    );
    this.isPurchaseTableBProductsControl.setValue(
      this.model.isPurchaseTableBProducts,
    );

    this.isAcceptRecommendedProductsControl.valueChanges.subscribe((value) => {
      this.isPurchaseTableBProductsControl.updateValueAndValidity();
    });
  };

  goToPreviousScreen = async () => {
    console.log('[RecommendedProductsComponent] goToPreviousScreen');
    await this.router.navigateByUrl('/fna/risk-profile-assessment');
  };

  onSubmit = async()=>{
    
    if (
      !(this.isAcceptRecommendedProductsControl.value === true &&
      this.isPurchaseTableBProductsControl.value === false)
    ) {
      
      this.model.doNotSkipWriteService = false;
      
    } 
    this.model.updateSavedData();
   
    this.model.onSubmit();
  }
  goToNextScreen = async () => {
    console.log('[RecommendedProductsComponent] goToNextScreen');
    if (
      this.isAcceptRecommendedProductsControl.value === true &&
      this.isPurchaseTableBProductsControl.value === false
    ) {
      await this.router.navigateByUrl('/fna/review-and-submit');
    } else {
      await this.router.navigateByUrl('/fna/non-recommended-products');
    }
  };

  formControlValueChanged() {
    this.isAcceptRecommendedProductsControl.valueChanges.subscribe((value) => {
      this.updateSideBarStepper();
    });
    this.isPurchaseTableBProductsControl.valueChanges.subscribe((value) => {
      this.updateSideBarStepper();
    });
  }

  updateSideBarStepper() {
    const hasNonRecommendedProductsStepper =
      this.isAcceptRecommendedProductsControl.value === false ||
      (this.isAcceptRecommendedProductsControl.value === true &&
        this.isPurchaseTableBProductsControl.value === true);

    this.sideBarService.showNonRecommendedProduct =
      hasNonRecommendedProductsStepper;
  }

  showRecommendedProduct() {
    const modalRef = this.modalService.open(
      DetailedProductDescriptionComponent,
      {
        modalDialogClass: 'fna-modal-dialog modal-fixed-height',
        scrollable: true,
      },
    );
    modalRef.componentInstance.title = 'Table A: Recommended products';

    if (this.model.assessedRiskProfile === RiskLevel.CONSERVATIVE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
    } else if (this.model.assessedRiskProfile === RiskLevel.MODERATE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
      modalRef.componentInstance.moderateRiskContent =
        this.model.recommendedProductsDetailDescription?.moderateRiskDescription;
    } else if (this.model.assessedRiskProfile === RiskLevel.AGGRESSIVE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
      modalRef.componentInstance.moderateRiskContent =
        this.model.recommendedProductsDetailDescription?.moderateRiskDescription;
      modalRef.componentInstance.highRiskContent =
        this.model.recommendedProductsDetailDescription?.highRiskDescription;
    }
  }

  showNonRecommendedProduct() {
    const modalRef = this.modalService.open(
      DetailedProductDescriptionComponent,
      {
        modalDialogClass: 'fna-modal-dialog modal-fixed-height',
        scrollable: true,
      },
    );
    modalRef.componentInstance.title = 'Table B: Non-recommended products';

    modalRef.componentInstance.lowRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.lowRiskDescription;
    modalRef.componentInstance.moderateRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.moderateRiskDescription;
    modalRef.componentInstance.highRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.highRiskDescription;
  }

  isAcceptRecommendedProductsOptionClick(event: any, radioValue: boolean) {
    if (
      this.model.hasSelectedNonRecommendedProducts === true &&
      !this.hasClearedPreviouslySelectedProducts &&
      this.model.isAcceptRecommendedProducts !== null
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              console.log('event.target.value: ', event);

              //TODO please actually call backend to clear data
              // This is just a flag
              this.hasClearedPreviouslySelectedProducts = true;

              this.isAcceptRecommendedProductsControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
    }
  }

  isPurchaseTableBProductsOptionClick(event: any, radioValue: boolean) {
    if (
      this.model.hasSelectedNonRecommendedProducts === true &&
      !this.hasClearedPreviouslySelectedProducts &&
      this.model.isPurchaseTableBProducts !== null
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              console.log('event.target.value: ', event);

              //TODO please actually call backend to clear data
              // This is just a flag
              this.hasClearedPreviouslySelectedProducts = true;

              this.isPurchaseTableBProductsControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
    }
  }

  // Form controls

  get isAcceptRecommendedProductsControl() {
    return this.form.get('isAcceptRecommendedProducts') as FormControl;
  }

  get isPurchaseTableBProductsControl() {
    return this.form.get('isPurchaseTableBProducts') as FormControl;
  }

  // Form controls end

  //region: getters

  get lowRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'low',
    );
  }
  get moderateRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'moderate',
    );
  }
  get highRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'high',
    );
  }

  get riskLevel(): typeof RiskLevel {
    return RiskLevel;
  }

  //endregion
}
